<template>
  <div class="declaration">
    <div class="declaration__title">
      <h3 class="declaration__title--white">{{ $t('declaration.title') }}</h3>
    </div>
    <div class="declaration__body">
      <el-card class="declaration__body__card">
        <Inputs
          @add-property="addProperty"
          :propertyEdited="property"
          @edited-property="editedProperty"
        />
        <el-button
          :type="buttonType"
          class="declaration__body__save"
          :disabled="!properties.length
            || !this.edited
            || (declarationLoading && properties.length)"
          :loading="declarationLoading && properties.length"
          @click="saveDeclaration">
          {{ $t(!properties.length || !this.edited ? 'base.saved' : 'base.save') }}
        </el-button>
        <Tab
          v-if="properties.length"
          :properties.sync="properties"
          :edited.sync="edited"
          @edit-property="editProperty" />
        <div v-else-if="!declarationStore.length">
          <h4 class="declaration__body__empty-declaration">
            {{ $t('declaration.emptyProperties') }}
          </h4>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Inputs from '@/components/declaration/Inputs.vue';
import Tab from '@/components/declaration/Tab.vue';

export default {
  name: 'declaration',
  components: {
    Inputs,
    Tab,
  },
  data() {
    return {
      properties: [],
      property: {},
      index: null,
      edited: false,
    };
  },
  computed: {
    ...mapGetters({
      projectSelected: 'projectStore/projectSelected',
      declarationStore: 'declarationStore/declaration',
      declarationCreated: 'declarationStore/declarationCreated',
      declarationLoading: 'declarationStore/declarationLoading',
    }),
    buttonType() {
      return this.edited ? 'warning' : 'success';
    },
  },
  methods: {
    ...mapActions({
      getDeclaration: 'declarationStore/getDeclaration',
      postDeclaration: 'declarationStore/postDeclaration',
      patchDeclaration: 'declarationStore/patchDeclaration',
    }),
    addProperty(property) {
      this.properties.push(property);
      this.edited = true;
    },
    editProperty(property, index) {
      this.index = index;
      this.property = { ...property };
    },
    editedProperty(property) {
      this.$set(this.properties, this.index, property);
      this.index = null;
      this.edited = true;
    },
    async saveDeclaration() {
      return this.declarationCreated
        ? this.patchDeclaration(this.properties).then(() => { this.edited = false; })
          .catch(() => {})
        : this.postDeclaration(this.properties).then(() => { this.edited = false; })
          .catch(() => {});
    },
  },
  created() {
    this.getDeclaration().then(() => {
      this.properties = [
        ...this.declarationStore,
      ];
    });
  },
  watch: {
    projectSelected() {
      this.getDeclaration().then(() => {
        this.properties = [
          ...this.declarationStore,
        ];
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.edited) {
      this.$confirm(
        this.$t('declaration.beforeLeave.text'),
        this.$t('declaration.beforeLeave.title'),
        {
          customClass: 'confirm__modal',
        },
      ).then(() => next()).catch(() => {});
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>

.declaration {
  min-height: 600px;
  margin: 0;
  @include breakpoint(tablet) {
    margin: 0 20px;
  }
  @include breakpoint(wide) {
    margin: 0 $--wide-margin;;
  }
  @include breakpoint(wide-xl) {
    margin: 0 $--wide-xl-margin;
  }
  &__title {
    margin-top: 20px;
    margin-left: 20px;
    @include breakpoint(tablet) {
      margin-left: 0px;
    }
    &--white {
      color: $--color-white;
    }
  }
  &__body {
    position: relative;
    margin: 20px 0;
    &__save {
      margin-top: 10px;
      @include breakpoint(mobile) {
        margin-top: 0;
      }
    }
    &__empty-declaration {
      text-align: center;
      opacity: 0.5;
    }
    &__card {
      border-radius: 0;
      @include breakpoint(tablet) {
        border-radius: 4px;
      }
    }
  }
}

</style>
